import { Button, Icon, message } from 'antd';
import React, { useState } from 'react';
import useCheckUploadByHoustingStock from '../../../../hooks/useCheckUploadByHoustingStock';
import { useSelector } from 'react-redux';
import useReceivableAccountTypes from '../../../../hooks/useReceivableAccountTypes';
import ModalUploadByHoustingStock from '../ModalUploadByHoustingStock/ModalUploadByHoustingStock';

const UploadByHoustingStock = () => {
  const currentCompany = useSelector(
    (store) => store.debtsStore.currentCompany
  );

  const [visible, setVisible] = useState(false);

  const { data, isFetching } = useCheckUploadByHoustingStock(
    currentCompany?.id,
    {
      enabled: !!currentCompany?.id,
    }
  );
  const { data: accountTypes, isLoading: isFetchingAccountTypes } =
    useReceivableAccountTypes(currentCompany?.id, {
      enabled: !!currentCompany?.id,
    });

  const isVisibleBtn = !!data?.accountForReceivables && !isFetching;

  const handleClose = () => {
    setVisible(false);
  };

  const handleClick = async () => {
    if (!accountTypes?.length) {
      message.info('В Жилом фонде нет данных по задолженности');
      return;
    }

    setVisible(true);
  };

  if (!isVisibleBtn) return null;

  return (
    <>
      <Button
        className="primary_button primary_button-circled button"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onClick={handleClick}
        disabled={isFetchingAccountTypes}
      >
        Загрузить из жилого фонда
        <Icon type={isFetchingAccountTypes ? 'loading' : 'plus'} />
      </Button>
      <ModalUploadByHoustingStock
        visible={visible}
        onCancel={handleClose}
        accountTypes={accountTypes}
      />
    </>
  );
};

export default UploadByHoustingStock;
